import React from "react";

export default class PublishKeenformCardComponent extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      make_public: this.props.keenform.make_public
    };
  }

  publishKeenform = () => {
    const publishUrl = `${window.location.href}/publish`,
    self = this;
    return window.fetch(publishUrl, {
      method: 'GET'
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(publishResponse) {
      self.setState({
        make_public: publishResponse === true
      });
    })
    .catch(function(error) {
      console.error('there was an error in publishing keenform: ', error);
    });
  }

  render(){
    let button_text = 'PUBLISH',
    button_class = 'btn-outline-info',
    icon_class = 'fa-door-open';
    if (this.state.make_public){
      button_text = 'DISABLE',
      button_class = 'btn-outline-default',
      icon_class = 'fa-door-closed';
    }
    return (<React.Fragment>
      <div className="card-header">
        <i className="fas fa-bullhorn"></i> PUBLISH
        <div className="card-header-desc">
          This form is currently <span className="keenform-status-description badge badge-info">{ this.state.make_public ? "PUBLIC" : "PRIVATE" }</span>
        </div>
      </div>

      <div className="card-body">
        <button
          onClick={() => {this.publishKeenform()}}
          type="button" 
          className={`btn btn-block ${button_class}`} 
          id="keenform-publish-button">
          <i className={`fas ${icon_class}`}></i> <span className="button-action-description">{ button_text }</span> FORM
        </button>
      </div>
    </React.Fragment>);
  }
}